import React from "react";
import style from './TagAantal.module.scss';

const TagAantal = (props) => {

    return <div style={{ padding:props.aantal.toString().length > 1 ? '0.1em 0.3em' : null}} className={`${props.className} ${style.tagRond}`}>
        {props.aantal !== null ? props.aantal : <i className="fas fa-spinner fa-pulse" />}
    </div>
}
export default TagAantal;